export const RIGHT_CARD_HEIGHT = 484;
export const BOTTOM_CARD_HEIGHT = 396;

// Title of various features within Transcripts
export const COPY_TRANSCRIPT_TITLE = 'Copy transcript';
export const SEARCH_TRANSCRIPT_TITLE = 'Search transcript';
export const UNDO_ALL_CORRECTIONS_TITLE = 'Undo all transcript changes';
export const CORRECT_TRANSCRIPT_TITLE = 'Correct transcript';
